import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import OptionsPanel from 'Components/OptionsPanel/OptionsPanel';
import EmployeeDaysAvailableScheduled from '../EmployeeDaysAvailableScheduled/EmployeeDaysAvailableScheduled';
import EmployeeHoursAvailableScheduled from '../EmployeeHoursAvailableScheduled/EmployeeHoursAvailableScheduled';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import Button from 'Components/Button/Button';
import ReasonAbsence from '../ReasonAbsence/ReasonAbsence';

const ListUserScheduleMonth = (
    {
        onUpdateResetFilterDay,
        resetFilterDay,
        sectorSelected,
        managerSelected,
        employeeSelected,
        selectedActualDate
    }) => {

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        '--modal-width-middle': '40%'
    };

    const [usersScheduledMonth, setUsersScheduledMonth] = useState(null);
    const [idScheduleSelected, setIdScheduleSelected] = useState([]);
    const [idDaySelected, setIdDaySelected] = useState([]);
    const [idHoursSelected, setIdHoursSelected] = useState([]);
    const [showReasonAbsence, setShowReasonAbsence] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        setIdDaySelected([])
        setIdHoursSelected([])
    }, [idScheduleSelected]);

    useEffect(() => {
        setUsersScheduledMonth(null)
        if (selectedActualDate && sectorSelected) {
            const fetchData = async () => {
                try {
                    setUsersScheduledMonth(await getUsersScheduledMonth());
                } catch (error) {
                    setUsersScheduledMonth([])
                }
            };
            fetchData();
        } else {
            setUsersScheduledMonth([])
        }
    }, [sectorSelected, managerSelected, employeeSelected, selectedActualDate]);

    useEffect(() => {
        if (!resetFilterDay) {
            return
        }
        onUpdateResetFilterDay(false);
        setUsersScheduledMonth(null)
        if (selectedActualDate) {
            const fetchData = async () => {
                setUsersScheduledMonth(await getUsersScheduledMonth());
            };
            fetchData();
        }
    }, [resetFilterDay]);


    useEffect(() => {
        setIdScheduleSelected([])
        setIdDaySelected([])
        setIdHoursSelected([])
    }, [sectorSelected, managerSelected]);

    async function getUsersScheduledMonth() {
        let currentDateOfMonth
        if (selectedActualDate) {
            currentDateOfMonth = new Date(selectedActualDate).toISOString().split('T')[0];
        }

        const parameters = {
            sectorId: sectorSelected,
            managerId: managerSelected,
            employeeId: employeeSelected,
            monthYear: currentDateOfMonth
        }

        const usersScheduledMonth = await ExecuteAxios.api('get', `/employee-hours-available/get-employees-with-available-hours-generated/`, { params: parameters })
        RemoveIdsNotFound.remove(usersScheduledMonth, setIdScheduleSelected, idScheduleSelected)
        return usersScheduledMonth
    }

    const styleSuspendEmployeeHoursButton = {
        width: '85px',
        float: 'right',
        color: 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    function getReasonAbsencePanel() {
        return (
            <Button
                clickMethod={() => { setShowReasonAbsence(true) }}
                buttonName={'Motivo ausência'}
                style={styleSuspendEmployeeHoursButton}
            />
        )
    }

    async function deleteEmployeeDaysHours() {

        if (idScheduleSelected && activeTab === 0) {

            let currentDateOfMonth
            if (selectedActualDate) {
                currentDateOfMonth = new Date(selectedActualDate).toISOString().split('T')[0];
            }

            const parameters = {
                groupIdsList: idScheduleSelected.join(","),
                monthYear: currentDateOfMonth
            };
            const response = await ExecuteAxios.api('delete', `/employee-hours-available/by-employees/`, { params: parameters });

            if (response) {
                setIdScheduleSelected([])
            }
            return response
        } else if (idDaySelected && activeTab === 1) {
            const parameters = {
                availableDaysId: idDaySelected.join(",")
            };
            const response = await ExecuteAxios.api('delete', `/employee-hours-available/by-days/`, { params: parameters });

            if (response) {
                setIdDaySelected([])
            }
            return response
        }
        onUpdateResetFilterDay(true)
    }

    return (
        <>
            <Panel titlePage={'Planejamento mensal'}
                style={panelListStyle}
                canViewCRUD={true}
                recordsSelected={idScheduleSelected}
                componentRightButtons={getReasonAbsencePanel()}
                className={'main-modal three middle'}
                deleteFunction={deleteEmployeeDaysHours}
                canDelete={true}
                enableDelete={
                    (idScheduleSelected && idScheduleSelected.length > 0 && activeTab === 0)
                    || (idDaySelected && idDaySelected.length > 0 && activeTab === 1)
                }
            >
                <ReasonAbsence
                    onUpdateResetFilterDay={val => { onUpdateResetFilterDay(val) }}
                    resetFilterDay={resetFilterDay}
                    sectorSelected={sectorSelected}
                    managerSelected={managerSelected}
                    employeeSelected={employeeSelected}
                    selectedActualDate={selectedActualDate}
                    showReasonAbsence={showReasonAbsence}
                    setShowReasonAbsence={setShowReasonAbsence}
                />
                <OptionsPanel
                    mainPanelStyle={{ height: 'calc(100% - 56px)' }}
                    goPreviousTab={true}
                    attributesToValidateSelectedOption={[idScheduleSelected, idDaySelected, idHoursSelected]}
                    onSelectOption={setActiveTab}
                    options=
                    {[
                        {
                            label: 'Geral',
                            readOnly: false,
                            component: (
                                <LoadingIndicator loaded={usersScheduledMonth}>
                                    <PanelListDefault
                                        onUpdateIdSelected={setIdScheduleSelected}
                                        idsSelected={idScheduleSelected}
                                        data={usersScheduledMonth}
                                        isEmptyPanel={usersScheduledMonth && usersScheduledMonth.length < 2}
                                    />
                                </LoadingIndicator>
                            )
                        },
                        {
                            label: 'Dias',
                            readOnly: !idScheduleSelected || idScheduleSelected.length === 0,
                            component: (
                                <EmployeeDaysAvailableScheduled
                                    idScheduleSelected={idScheduleSelected}
                                    idDaySelected={idDaySelected}
                                    onUpdateIdDaySelected={setIdDaySelected}
                                    resetFilterDay={resetFilterDay}
                                />
                            )
                        },
                        {
                            label: 'Horas',
                            readOnly: !idDaySelected || idDaySelected.length === 0,
                            component: (
                                <EmployeeHoursAvailableScheduled
                                    idDaySelected={idDaySelected}
                                    idHoursSelected={idHoursSelected}
                                    onUpdateIdHoursSelected={setIdHoursSelected}
                                    onUpdateIdDaySelected={setIdDaySelected}
                                    onUpdateIdScheduleSelected={setIdScheduleSelected}
                                    onUpdateResetFilterDay={onUpdateResetFilterDay}
                                    resetFilterDay={resetFilterDay}
                                />
                            )
                        }
                    ]}
                />
            </Panel >
        </>
    )
};

export default ListUserScheduleMonth;
